import React from 'react'

export default function Homepage() {
    return (
        <div className='px-[24px]'>Home page</div>
    )
}
